import { useMemo } from 'react';
import { useDateLocale } from '@/hooks/useDateLocale';
import { createDateFormatters, type DateFormatters } from '@/utils/dateFormat';

/**
 * Date formatters bound to the active language.
 *
 * Prefer this over `format()`, `toLocaleDateString` and friends anywhere the
 * result is shown to a user — the eslint rule in this repo will tell you so.
 * Lookup keys and form values are the exception: use `toDateKey` / `toTimeKey`
 * from `@/utils/dateFormat`, which are locale-free on purpose.
 */
export function useDateFormat(): DateFormatters {
  const locale = useDateLocale();
  return useMemo(() => createDateFormatters(locale), [locale]);
}

export default useDateFormat;
